module.exports = __webpack_public_path__ + "img/timeline.9daa1c13.svg";